import { ResultOf } from 'gql.tada'
import { CURRENT_COMPANY_NOTIFICATION_SETTINGS_QUERY } from 'modules/companies/queries'

export type CompanyWithNotificationSettings = ResultOf<
  typeof CURRENT_COMPANY_NOTIFICATION_SETTINGS_QUERY
>['currentCompany']

export const NotificationSettings = {
  USER_REGISTRATION: 'userRegistration',
  RESET_PASSWORD: 'resetPassword',
  USER_DOCUMENT: 'userDocument',
  ISSUE_CREATED: 'issueCreated',
  ISSUE_CLOSED: 'issueClosed',
  ABSENCE_CREATED: 'absenceCreated',
  ABSENCE_STATUS_CHANGED: 'absenceStatusChanged',
  FORUM_THREAD_CREATED: 'forumThreadCreated',
  FORUM_POST_CREATED: 'forumPostCreated',
  DRIVER_CARD_WILL_EXPIRE: 'driverCardWillExpire',
  USER_EXPORT_READY: 'userExportReady',
  VEHICLE_EXPIRATION: 'vehicleExpiration',
  VEHICLE_DOCUMENT: 'vehicleDocument',
  NEW_INFRINGEMENT: 'notifyOnInfringement',
  ISSUE_REMINDER: 'issueReminder',
  PLANNER_CALENDAR_EVENT_CHANGE: 'plannerCalendarEventChange',
}

export type NotificationSettingsNames = keyof typeof NotificationSettings
